import React from "react";
import MakePaymentsFrom from "./makePaymentsFrom";
import {
  getUUID,
  getBankDisplayName,
  isSelectedField,
  getAccount,
  isSameBankAccount,
  splitRouting
} from "../../utils/cl_apply_utility";
import { updateStandardDataLayerAttributes, setBankDetailsDataLayer } from "../../analytics/adobe/index";
import { bankDetailsDataLayer } from "../../analytics/adobe/dataLayerValues";
import { INAVLID_MESSAGES } from "../../constants";

const messages = INAVLID_MESSAGES.ACCOUNT;

class DepositMyLoan extends React.Component {

    state = {
      showDiv: false,
      depositLoanAccount: {},
      selectValue: "Select account",
      dropdownSelected: false,
      accountsList: [],
      isAccountSelectionError: false,
      tempInvalidAcc: null,
      isStateChanged: false,
      isRoutingNumberError: null,
      isInvalidRouting: false
    }
    constructor(props) {
      super(props);
      this.state.accountsList = this.props.externalAccountDetails;
      this.handleSelectBtn1Click = this.handleSelectBtn1Click.bind(this);
      this.updateDropdown = this.updateDropdown.bind(this);
    }

    componentDidMount() {
      let accDetails ={ ...this.props.offerPreFilled.crossSellPersonalizedQuote };
      const { pageName, siteSection }=bankDetailsDataLayer;
      updateStandardDataLayerAttributes(setBankDetailsDataLayer(pageName, siteSection, accDetails.termInMonths, accDetails.loanAmount), true);
    }

    componentWillMount() {
      let acc ={ ...this.props.offerPreFilled.loanBankInfo.depositAccountDetails };
      const newAccount = this.getAccountList();
      if(isSelectedField(acc, 'nickname', 'accountNumber')){
        this.state.depositLoanAccount =acc;
        this.state.selectValue = getBankDisplayName(this.state.depositLoanAccount.nickname, this.state.depositLoanAccount.accountNumber);
        this.state.dropdownSelected = true;
      }
      if(newAccount && newAccount.length >= 1){
        let acc=getAccount(newAccount, "DEPOSIT");
        if(acc){
          this.state.depositLoanAccount =acc;
          this.state.selectValue = getBankDisplayName(this.state.depositLoanAccount.nickname, this.state.depositLoanAccount.accountNumber);
          this.state.dropdownSelected = true;
        }
      }
    }

  handleSelectBtn1Click = () => {
    this.setState({ dropdownSelected: !this.state.dropdownSelected });
  }
  updateDropdown(e, index, isAccountMatch) {
    let accDetails = this.getAccountList()[index];
    let isStateChanged={};
    if(!isSameBankAccount(accDetails, this.state.depositLoanAccount)){
      isStateChanged={ isStateChanged: true, isRoutingNumberError: null, isInvalidRouting: false };
    }
    this.setState({ selectValue: e, depositLoanAccount: accDetails, isAccountMatch: isAccountMatch, ...isStateChanged });
  }
    getAccountList=()=>{
      let accInfo = this.props.bankAccountInfo, accountsList=this.state.accountsList;
      if(accInfo && "bankAccountDetails" in accInfo){
        if(accInfo.bankAccountDetails.length !==0){
          accountsList = accountsList.concat(accInfo.bankAccountDetails);
        }
      }
      return accountsList;
    }
    errorHandle = (isError, routingNumberNotification) =>{
      const depositLoanAccount ={ ...this.state.depositLoanAccount };
      let isRoutingNumberError = splitRouting(routingNumberNotification, "DEPOSIT");
      this.setState({
        tempInvalidAcc: isError?depositLoanAccount.accountNumber:null,
        isAccountSelectionError: isError,
        isRoutingNumberError: isRoutingNumberError,
        isInvalidRouting: isRoutingNumberError?true:false
      });
    }
    resetState=()=>{
      this.setState({ isStateChanged: false });
    }
render = () => {
  let retryacc = this.props.idvresponse?this.props.idvresponse.accountNumber:null;
  const template =(<div key="add-bank-key-565001" className="standard-blue padding-10-date select-dropdown-margin-left" tabIndex="0" onKeyDown={e=>{ if(this.state.showDiv) { let key = e.keyCode;let min = 0;let max = dropdownBody.childElementCount;if (key === 38) { currentIndex > min ? currentIndex-- : null; } else if (key === 40) { currentIndex < max ? currentIndex++ : null; }let childNodes = dropdownBody && dropdownBody.children;childNodes[currentIndex].focus(accountNumbers);if(key === 13 || key === 32) { this.props.switchTab("DEPOSIT"); } } }}><a className="standard-blue text-underline" data-track="custom-links" onClick={()=>this.props.switchTab("DEPOSIT")}>Add bank account</a></div>);
  const accountsList = this.getAccountList();
  const { showDiv } = this.state;
  const { paymentDueDate } = this.props.applicantDetails.crossSellPersonalizedQuote;
  const selectedAcc = this.state.tempInvalidAcc;
  const isError=this.state.isAccountSelectionError;
  const currentAc=this.state.depositLoanAccount.accountNumber;
  let isInvalidAc=(isError && currentAc === selectedAcc);

  const isInvalidRoutingNumber = this.state.isInvalidRouting;
  isInvalidAc = isInvalidRoutingNumber || isInvalidAc;
  const isInValidAccount = isInvalidRoutingNumber?this.state.isRoutingNumberError.acc:null;
  const isInValidRN = isInvalidRoutingNumber?this.state.isRoutingNumberError.routing:null;
  const errorMessage = messages.ACC_INVALID;

  const accountNumbers = accountsList.map((ac, index) =>{
    const isAccountMatch = (isError && selectedAcc === ac.accountNumber) ||
        (isInvalidRoutingNumber && (isInValidAccount === ac.accountNumber && isInValidRN === ac.routingNumber));

    const key = getUUID();
    const dispKey = getBankDisplayName(ac.nickname, ac.accountNumber);
    const colorToggle =isAccountMatch?"color-red":"standard-blue";
    return (<div key={`${key}-${index}`} className={`padding-10-date select-dropdown-margin-left ${colorToggle}`}
      onClick={() => { this.setState({ showDiv: !showDiv });this.updateDropdown(dispKey, index); }}
      tabIndex="0"
      onKeyDown={e=>{
        if(this.state.showDiv) {
          let key = e.keyCode;
          let min = 0;
          let max = dropdownBody.childElementCount;
          if (key === 38) {
            currentIndex > min ? currentIndex-- : null;
          } else if (key === 40) {
            currentIndex < max ? currentIndex++ : null;
          }
          let childNodes = dropdownBody && dropdownBody.children;
          childNodes[currentIndex].focus(accountNumbers);
          if(key === 13 || key === 32) {
            this.setState({ showDiv: !showDiv });
            this.updateDropdown(dispKey, index);
          }
        }
      }} role="option">{dispKey}</div>);
  });
  accountNumbers.push(template);
  let dropdownBody = document.getElementById("depositMyLoanBody");
  let currentIndex = 0;
  return (
    <div className="card border-not-required">
      <article>
        <section
          className="card border-not-required col-sm-12 col-lg-12 col-md-12 col-xs-12 padding-l-r-5 loan-details card-header-section">
          <div className="your-loan-details margin-bottom-10" id="deposit-label">Deposit my loan to</div>
          <div className="loan-details">
            <div className={`loan-details-section  ${isInvalidAc?"color-border-red":""}`}
              onKeyDown={e=>{
                let key=e.keyCode;
                key===13?this.setState({ showDiv: !this.state.showDiv }):null;
                key===32?this.setState({ showDiv: true }):null;
                key===27?this.setState({ showDiv: false }):null;
                if((key===38||key===40||key==13||key===32)&&!this.state.showDiv){
                  this.setState({ showDiv: true }, ()=>{
                    this.setState({ showDiv: true });
                  });
                } else if((key===38||key===40||key==13||key===32)&&this.state.showDiv){
                  let childNodes = dropdownBody && dropdownBody.children;
                  childNodes && childNodes[0].focus(accountNumbers);
                }
              }} tabIndex="0" aria-labelledby="deposit-label" role="combobox" aria-controls="depositMyLoanBody" aria-expanded={showDiv}>
              <div className={`padding-10-date select-dropdown-margin-left ${isInvalidAc?"arrow-condition color-red":"standard-blue"}`}
                value={this.state.selectValue} onClick={() => { this.setState({ showDiv: !showDiv }); this.handleSelectBtn1Click; }}
              >
                {this.state.selectValue}
                <div className={this.state.showDiv? 'arrow-down' : 'arrow'} />
              </div>
            </div>
          </div>

          { showDiv && (
            <div className="loan-details margin-t-10">
              <div className="loan-details-section padding-top-bottom-10" id="depositMyLoanBody" role="listbox" aria-labelledby="deposit-label">

                { accountNumbers }

              </div>
            </div>
          )}
          {isInvalidAc?
            <p className={`${isInvalidAc?"color-red":"standard-blue"}`} role="alert"><b>Error:</b> {errorMessage}</p>
            :null
          }
          <MakePaymentsFrom {...this.props} paymentDueDate={paymentDueDate}
            dropdownSelected={this.state.selectValue}
            externalAccountDetails={accountsList}
            switchTab={this.props.switchTab}
            depositAcc={this.state.depositLoanAccount}
            errorHandle={this.errorHandle}
            isStateChanged={this.state.isStateChanged}
            resetState={this.resetState}
            handleRepeatPaymentSelection={this.props.handleRepeatPaymentSelection}
          />
        </section>
      </article>
    </div>
  );
}
}
export default DepositMyLoan;
